module.exports = __webpack_public_path__ + "img/us.69aafcf8.svg";